<template>
    <div>
        <!-- <div v-if="user.role == null">
          <v-content>
            <v-container fluid fill-height fill-wheight>
              <v-layout justify-center align-center>
                <WaveyBackground />
              </v-layout>
            </v-container> </v-content
          >'
        </div> -->
        <!--    <div v-if="isLogin()" :key="updateComponent">-->
        <div :key="updateComponent">
            <v-app id="inspire">
                <!--		          class="p-d-none p-d-md-inline"-->

                <v-navigation-drawer
                        expand-on-hover
                        v-if="isUserAtStore"
                        class="p-d-none p-d-md-inline"
                        :mini-variant="mini"
                        hide-overlay
                        clipped
                        v-model="drawer"
                        app
                        right
                >
                    <v-list class="pa-1">
                        <v-list-tile avatar tag="div">
                            <v-list-tile-avatar v-if="isUserAtStore">
                                <img :src="user.image"/>
                            </v-list-tile-avatar>

                            <v-list-tile-content v-if="isUserAtStore">
                                <v-list-tile-title v-if="user.grade === null"
                                >{{ user.firstname }} {{ user.lastname }}
                                </v-list-tile-title>
                                <v-list-tile-title v-else-if="user.role === 'USER'">{{
                                        getGradeName(user.grade)
                                    }}
                                </v-list-tile-title>
                                <v-list-tile-title v-else
                                >מנהל {{ user.firstname }}
                                    {{ user.lastname }}
                                </v-list-tile-title
                                >
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon @click.stop="mini = !mini">
                                    <v-icon>chevron_right</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                    <v-divider light></v-divider>

                    <v-list dense>
                        <v-list-tile
                                v-for="item in items"
                                :key="item.title"
                                @click="clickRouter(item.route)"
                                class="z"
                        >
                            <v-list-tile-action>
                                <p :data-intro="`${item.intro}`">
                                    <v-icon>{{ item.icon }}</v-icon>
                                </p>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <div v-if="user.grade !== null || user.role === 'ADMIN'">
                            <v-list-tile
                                    v-for="item in userItems"
                                    :key="item.title"
                                    @click="clickRouter(item.route)"
                            >
                                <v-list-tile-action>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-tile-action>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </div>

                        <div v-else>
                            <v-list-tile
                                    v-for="item in userPartialItems"
                                    :key="item.title"
                                    @click="clickRouter(item.route)"
                            >
                                <v-list-tile-action>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-tile-action>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </div>


                        <div v-if="user.role === 'ADMIN'">
                            <v-list-tile
                                    v-for="item in adminItems"
                                    :key="item.title"
                                    @click="clickRouter(item.route)"
                            >
                                <v-list-tile-action>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-tile-action>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </div>
                    </v-list>
                </v-navigation-drawer>

                <v-toolbar v-if="isUserAtStore" app fixed clipped-left>
                    <v-toolbar-side-icon
                            class="p-d-none p-d-md-inline-flex"
                            @click.stop="mini = !mini"
                    ></v-toolbar-side-icon>
                    <v-toolbar-side-icon class="p-d-md-none">
                        <img
                                :src="imageMobile"
                                style="
                height: 55px;
                margin-top: 0px;
                padding-bottom: 7px;
                padding-top: 6px;
              "
                        />
                    </v-toolbar-side-icon>

                    <v-toolbar-title>
                        <img
                                :src="imageDesktop"
                                class="p-d-none p-d-md-inline-flex"
                                style="height: 55px; margin-top: 5px"
                        />
                    </v-toolbar-title>

                    <v-layout align-center justify-end row fill-height>
                        <!--            <h3-->
                        <!--                style="text-align:center; height: 55px; margin-top: 30px; margin-left: 30px; color: red"-->
                        <!--            > test </h3>-->
                        <v-dialog v-model="dialog" max-width="600px" dark>
                            <template #activator="{ on: dialog }">
                                <div class="p-pt-2">

                                    <Dropdown
                                            class="p-d-none p-d-md-inline-flex"
                                            dataKey="id"
                                            optionLabel="hebrewName"
                                            v-model="selectedDateRange"
                                            :options="dateRangeOptions"
                                            @change="onSelectDateRange"
                                   />
                                    <Dropdown
                                            class="p-d-md-none"
                                            dataKey="id"
                                            optionLabel="shortName"
                                            v-model="selectedDateRange"
                                            :options="dateRangeOptions"
                                            @change="onSelectDateRange"
                                   />

                                    <!--                  <i class=" button-top-menu pi pi-sun p-mr-4" style="font-size: 1.2rem"></i>-->

                                    <!--                  <span  v-tooltip.top="'התנתק'">-->

                                    <i
                                            :key="topMenuUpdate"
                                            v-tooltip.top="'מידע'"
                                            @click="isInformationDialog = true"
                                            v-if="userSettings.informationViewed"
                                            class="button-top-menu pi pi-info-circle p-mr-4"
                                            style="font-size: 1.2rem"
                                    ></i>

                                    <i
                                            :key="topMenuUpdate"
                                            v-tooltip.top="'מידע'"
                                            @click="isInformationDialog = true"
                                            v-else
                                            class="button-top-menu pi pi-info-circle p-mr-4"
                                            style="font-size: 1.2rem"
                                            v-badge.danger="1"
                                    ></i>

                                    <i
                                            v-tooltip.top="'התנתק'"
                                            class="button-top-menu pi pi-sign-out p-mr-4"
                                            style="font-size: 1.2rem"
                                            @click="logout"
                                    ></i>
                                </div>
                            </template>
                        </v-dialog>
                    </v-layout>
                </v-toolbar>

                <v-content>
                    <v-layout fluid fill-height fill-wheight>
                        <!-- <div
                          v-if="!isStateReady"
                          style="
                            display: flex;
                            width: 100vw;
                            height: 100vh;
                            align-items: center;
                          "
                        >
                          <ProgressSpinner
                            style="width: 100px; height: 100px"
                            strokeWidth="3"
                            animationDuration="2s"
                            v-if="!isStateReady"
                          />
                        </div> -->
                        <WaveyBackground/>
                    </v-layout>
                </v-content>
            </v-app>
        </div>

        <informationDialog
                :show="isInformationDialog"
                v-on:closeDialog="isInformationDialog = false"
        >
        </informationDialog>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import eventbus from "@/plugins/eventbus";
import WaveyBackground from "@/components/WaveyBackground";
import informationDialog from "../dialogs/informationDialog";
import Login from "../views/Login";
import axios from "axios";
import Vue from "vue";

export default {
    created() {
        eventbus.$on("closedialog", () => (this.dialog = false));
        this.fillDateRange()


    },
    components: {
        WaveyBackground,
        informationDialog,
        Login,
    },
    data: () => ({
        selectedDateRange: null,
        isInformationDialog: false,
        classMode: "dark-mode",
        updateComponent: 0,
        topMenuUpdate: 0,
        dialog: false,
        drawer: true,
        mini: true,
        items: [],
        dateRangeOptions: [
            {id: 'a', hebrewName: 'תשפג', startDate: 1, endDate: 555},
            {id: 'b', hebrewName: 'תשפד', startDate: 666, endDate: 777},
            {id: 'z', hebrewName: 'תשפz', startDate: 888, endDate: 999},
            {id: 'q', hebrewName: 'תשפzq', startDate: 1000, endDate: 9999999999999},
        ],
        userItems: [
            {
                title: "דף הבית",
                icon: "pi-calendar",
                route: "/",
                intro: `דף הבית`,
            },
            {
                title: "דשבורד תלמיד",
                icon: "pi-image",
                route: "/pupil-dashboard",
                intro: `דשבורד תלמיד`,
            },
            {
                title: "דשבורד כיתה",
                icon: "pi-images",
                route: "/grade-dashboard",
                intro: `דשבורד כיתה`,
            },
            {
                title: "מבחנים",
                icon: "pi-pencil",
                class: "p-button-warning",
                route: "/test",
                intro: `מבחנים`,
            },
            {
                title: "התקדמות בלימוד",
                icon: "pi-book",
                route: "/study",
                intro: `התקדמות בלימוד`,
            },
            {
                title: "תיק אישי",
                icon: "pi-briefcase",
                route: "/tracing",
                intro: `תיק אישי`,
            },
            {
                title: "נוכחות",
                icon: "pi-calendar-minus",
                route: "/presence",
                intro: `נוכחות`,
            },
            {
                title: "תעודות",
                icon: "pi-bookmark",
                route: "/report",
                intro: `תעודות`,
            },
            {
                title: "מערכת שעות",
                icon: "pi-clock",
                route: "/schedule",
                intro: `מערכת שעות`,
            },

        ],
        userPartialItems: [
            {
                title: "דף הבית",
                icon: "pi-calendar",
                route: "/",
                intro: `דף הבית`,
            },
            {
                title: "מבחנים",
                icon: "pi-pencil",
                class: "p-button-warning",
                route: "/test",
                intro: `מבחנים`,
            },
            {
                title: "התקדמות בלימוד",
                icon: "pi-book",
                route: "/study",
                intro: `התקדמות בלימוד`,
            },
            {
                title: "תיק אישי",
                icon: "pi-briefcase",
                route: "/tracing",
                intro: `תיק אישי`,
            },
            {
                title: "נוכחות",
                icon: "pi-calendar-minus",
                route: "/presence",
                intro: `נוכחות`,
            },
            {
                title: "תעודות",
                icon: "pi-bookmark",
                route: "/report",
                intro: `תעודות`,
            },
            {
                title: "מערכת שעות",
                icon: "pi-clock",
                route: "/Schedule",
                intro: `מערכת שעות`,
            },
        ],
        adminItems: [
            {
                title: "משתמשים",
                icon: "pi-id-card",
                route: "/user",
                intro: `משתמשים`,
            },
            {
                title: "תלמידים",
                icon: "pi-users",
                route: "/pupil",
                intro: `,תלמידים`,
            },
            {
                title: "נתוני מערכת",
                icon: "pi-th-large",
                route: "/generalData",
                intro: `נתוני מערכת`,
            },

        ],
    }),
    computed: {
        imageDesktop() {
            return require(`${process.env.VUE_APP_IMAGE_HAEDER}`);
        },
        imageMobile() {
            return require(`${process.env.VUE_APP_LOGO}`);
        },
        isLoginAndReadyOrNotLogin() {
            // if (this.isUserAtLocal){
            //   return this.isStateReady
            // } else {
            return true;
            // }
        },
        isStateReadyComputed() {
            return this.isStateReady;
        },
        isUserAtLocal() {
            return localStorage.getItem("authorization") !== null;
        },
        isUserAtStore() {
            return this.user !== null;
        },
        isInformationViewed() {
            // return  true
            return this.userSettings.informationViewed === false;
        },
        ...mapState([
            "isStateReady",
            "userSettings",
            "user",
            "isStateReady",
            "gradeOptions",
        ]),
    },
    watch: {
        isStateReady() {
            this.updateComponent++;
        },
        userSettings() {
            this.topMenuUpdate++;
            // alert(newVal)
            // this.updateComponent++
        },
        user(a, b) {
            this.updateComponent++;
            // alert(newVal)
            // this.updateComponent++
        },
    },
    methods: {
        async fillDateRange(){
            try {
                const {data} = await axios.get('system-date/all')

                this.dateRangeOptions = data.filter(date => date.active)
                const selectedRangeId = Vue.ls.get('systemDateRangeId', null)
                const matchDateRange = this.dateRangeOptions.find(r => r.id === selectedRangeId)
                if (matchDateRange) {
                    this.selectedDateRange = matchDateRange
                } else {
                    this.selectedDateRange = this.dateRangeOptions.find(d => d.default === true) || this.dateRangeOptions[this.dateRangeOptions.length - 1]
                }

                Vue.ls.set('startDateDefaultRequest', this.selectedDateRange.startDate)
                Vue.ls.set('endDateDefaultRequest', this.selectedDateRange.endDate)
                axios.defaults.headers.common['startDate'] = this.selectedDateRange.startDate
                axios.defaults.headers.common['endDate'] = this.selectedDateRange.endDate
                Vue.ls.set('systemDateRangeId', this.selectedDateRange.id)
            } catch (e) {
                console.log(e)
            }
        },
        onSelectDateRange(event) {
            console.log("event", event)

            const rangeId = event.value.id
            const startDate = event.value.startDate
            const endDate = event.value.endDate
            Vue.ls.set('startDateDefaultRequest', startDate)
            Vue.ls.set('endDateDefaultRequest', endDate)
            if (startDate) axios.defaults.headers.common['startDate'] = startDate
            if (endDate) axios.defaults.headers.common['endDate'] = endDate
            Vue.ls.set('systemDateRangeId', rangeId)
            this.updateComponent++;

        },
        isLogin() {
            return localStorage.getItem("authorization") !== null;
        },
        getGradeName(gradeId) {
            return this.gradeOptions?.find((grade) => grade.id === gradeId)
                .hebrewName;
        },
        themex() {
            this.changeMode();
        },
        ...mapActions(["setUser", "changeMode", "stateNotReady"]),
        changeLang() {
            this.$i18n.locale === "he"
                ? (this.$i18n.locale = "en")
                : (this.$i18n.locale = "he");
            this.$vuetify.rtl = !this.$vuetify.rtl;
        },
        logout() {
            localStorage.removeItem("authorization");
            axios.defaults.headers.common['authorization'] = null
            this.setUser(null);
            this.stateNotReady();
            this.$router.push({path: "login"});
            this.updateComponent++;
        },
        clickRouter(newRoute) {
            this.$router.push(newRoute).catch(() => {
                this.$router.go(0);
            });
        },
    },
    mounted() {
        if (localStorage.getItem("authorization")) {
            // this.setUser(
            //   JSON.parse(jwt_decode(localStorage.getItem("authorization")))
            // );
        }
    },
};
</script>

<style scoped>
.p-dropdown {
    background-color: var(--primary-color);
    border: none !important;
}

.v-toolbar {
    padding-right: 0 !important;
}

.v-footer {
    padding-right: 2%;
}

/* .v-list-item--active {
  background: lightgoldenrodyellow !important;
}
.v-list__tile.v-list__tile--link.theme--light {
  background: lightgoldenrodyellow !important;
}
.v-navigation-drawer > .v-list .v-list__tile {
  background: lightgoldenrodyellow !important;
}
.v-list__tile__action {
  background: lightgoldenrodyellow !important;
}
.v-list__tile--link {
  background: lightgoldenrodyellow !important;
}
.v-list__tile {
  background-color: aqua;
  color: blue;
  background: lightgoldenrodyellow !important;
} */
.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
}

.dot-button {
    /*display: ;*/

    background-color: #ea0505;
    z-index: 100;
    border-radius: 100%;
    width: 6px;
    height: 6px;
    position: absolute;
    /*left: 70px;*/
    /*margin-bottom: 15px;*/
    /*margin-left: -10px;*/
    /*margin-bottom: 18px;*/
}

.p-tooltip-text {
    z-index: 7 !important;
}

.p-overlay-badge {
    margin-right: 2rem;
}

.button-top-menu {
    cursor: pointer;
}

.p-overlay-badge .p-badge {
    position: absolute;
    /*top: 4;*/
    /*right: 5;*/
    /* transform: scale(1.5); */
    -webkit-transform: translate(-50%, -50%) scale(0.6) !important;
    /*transform: scale(0.7);*/
    transform: translate(-50%, -50%) scale(0.7) !important;
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0;
    margin: 0;
    /*padding: 5p;*/
}
</style>
